import { Box } from "@mantine/core";
import React from "react";
import { AnimatedHero } from "./components/AnimatedHero";
import { FeatureShowcase } from "./components/FeatureShowcase";
import { FinalCTA } from "./components/FinalCTA";
import { Testimonials } from "./components/Testimonials";
import classes from "./LandingPage.module.css";

const LandingPage: React.FC = () => {
  return (
    <Box className={classes.wrapper}>
      <Box className={classes.hero}>
        <AnimatedHero />
      </Box>
      <Box className={classes.featureSection}>
        <FeatureShowcase />
      </Box>
      <Box className={classes.testimonialsSection}>
        <Testimonials />
      </Box>
      <Box className={classes.ctaSection}>
        <FinalCTA />
      </Box>
    </Box>
  );
};

export default LandingPage;
